import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InsertPageBreakRoundedIcon from "@mui/icons-material/InsertPageBreakRounded";
import PersonIcon from "@mui/icons-material/Person";
import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AttachmentViewer from "../../../app/core/components/AttachmentViewer/AttachmentViewer";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CorePracticeTags from "../../../app/core/components/CorePracticeTags/CorePracticeTags";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreStatus from "../../../app/core/components/CoreStatus/CoreStatus";
import { transformCategoriesForSelectObjArr } from "../../../utils/functions/categories";
import {
  useDoChangeStatusMutation,
  useDoPriorityDocMutation,
  useRejectDocumentMutation,
} from "../../api/admin/gestisciDocumentiApi";
import {
  useGetAllChildrensQuery,
  useGetAllFamiliesQuery,
  useGetUserAllCFQuery,
} from "../../api/admin/gestisciUtentiApi";
import SchedaUtente from "../../common/SchedaUtente/SchedaUtente";
import SplitDocumentPage from "../SplitDocumentPage/SplitDocumentPage";
import CUFormContainer from "./CUFormContainer";
import DynamicForm from "./DynamicForm";
import PlainForm from "./PlainForm";

const SingleDocumentPage = ({ document, closeModal, documents, onOpenDoc }) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const isPlainFormWithUserNotes =
    appConfig?.modules?.documents?.form?.isPlainFormWithUserNotes;
  const macroCategoriesData = useSelector(
    (state) => state.categories.macroCategories
  );

  const [currentDocument, setCurrentDocument] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [open, setOpen] = useState(false);
  const [boundingBox, setBoundingBox] = useState();
  const [extractedDocument, setExtractedDocument] = useState("");
  const [openDiscardDialog, setOpenDiscardDialog] = useState(false);
  const [notesDiscard, setNotesDiscard] = useState("");

  const [openUserModal, setOpenUserModal] = useState(false);

  const [categoryData, setCategoryData] = useState(null);
  const [macroCategoriesList, setMacroCategoriesList] = useState(null);
  const [subCategoriesList, setSubCategoriesList] = useState(null);

  const { data: fiscalCodes } = useGetUserAllCFQuery(currentDocument?.userId, {
    skip: !currentDocument?.userId,
  });
  const { data: children } = useGetAllChildrensQuery(currentDocument?.userId, {
    skip: !currentDocument?.userId,
  });
  const { data: family } = useGetAllFamiliesQuery(currentDocument?.userId, {
    skip: !currentDocument?.userId,
  });

  const [rejectDocument, { isLoading: isRejectLoading }] =
    useRejectDocumentMutation();

  const [changeStatus] = useDoChangeStatusMutation();
  const [priorityDoc] = useDoPriorityDocMutation();

  const disablePrev = documents
    ? documents.findIndex((id) => id === currentDocument?.id) === 0
    : true;
  const disableNext = documents
    ? documents.findIndex((id) => id === currentDocument?.id) ===
      documents?.length - 1
    : true;

  useEffect(() => {
    if (document) {
      setCurrentDocument(document);
      setCategoryData({
        macroCategory: document?.mainCategoryId,
        subCategory: document?.categoryId,
      });
    }
  }, [document]);

  useEffect(() => {
    if (
      currentDocument &&
      currentDocument?.files[0]?.extension?.toLowerCase() === "pdf"
    ) {
      const loadPdf = async () => {
        try {
          const pdf = await pdfjs.getDocument(
            `${process.env.REACT_APP_API_URL}${currentDocument.files[0].url}`
          ).promise;
          setNumPages(pdf.numPages);
        } catch (error) {
          console.log(error);
        }
      };
      loadPdf();
    }
  }, [currentDocument]);

  // prendiamo i dati della IA
  useEffect(() => {
    if (currentDocument && currentDocument?.extractedDocument) {
      let data = currentDocument?.extractedDocument
        .replace(/\\r\\n/g, "")
        .replace(/\\(?!\\)/g, "") // Rimuove solo le singole \
        .replace(/\\\\/g, "\\"); // Sostituisce doppie barre \\ con una sola \

      try {
        const jParsedData = JSON.parse(data);
        setExtractedDocument(jParsedData);
      } catch (error) {
        toast.error(t("ErrorRetrievingCategoriesData"));
        setExtractedDocument(null);
      }
    }
  }, [currentDocument]);

  useEffect(() => {
    if (extractedDocument) {
      const objectBounding = extractedDocument.fields?.map((el) => ({
        boundingBox: el.boundingBox,
        page: el.page,
        numPages: extractedDocument?.pages?.length || 0,
        rotation:
          extractedDocument?.pages?.find((page) => page.index === el.page)
            ?.angle || 0,
      }));
      setBoundingBox(objectBounding);
    }
  }, [extractedDocument, currentDocument]);

  useEffect(() => {
    setMacroCategoriesList(
      transformCategoriesForSelectObjArr(macroCategoriesData)
    );
    setSubCategoriesList(
      transformCategoriesForSelectObjArr(
        macroCategoriesData.filter(
          (mC) => mC.id === currentDocument?.mainCategoryId
        )[0]?.expenseCategories
      )
    );
  }, [macroCategoriesData, currentDocument?.mainCategoryId, currentDocument]);

  useEffect(() => {
    if (currentDocument?.status === 3) {
      changeStatus({ id: currentDocument.id, status: 5 });
    }
  }, [currentDocument, changeStatus]);

  useEffect(() => {
    if (documents.length === 0) closeModal();
  }, [documents, closeModal]);

  const handleOpenUserModal = () => {
    setOpenUserModal(true);
  };

  const handleCloseUserModal = () => {
    setOpenUserModal(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleGoToPreviousDocument = () => {
    const currentIndex = documents.findIndex(
      (id) => id === currentDocument?.id
    );
    if (currentIndex > 0) {
      setExtractedDocument(null);
      setBoundingBox(null);
      setCurrentDocument(null);
      onOpenDoc(documents[currentIndex - 1]);
      return;
    }
  };

  const handleGoToNextDocument = () => {
    const currentIndex = documents.findIndex(
      (id) => id === currentDocument?.id
    );
    if (currentIndex < documents.length - 1) {
      setExtractedDocument(null);
      setBoundingBox(null);
      setCurrentDocument(null);
      onOpenDoc(documents[currentIndex + 1]);
      return;
    }
  };

  const handleMacroCategoryChange = (event) => {
    const selectedValue = event.target.value;
    const category = macroCategoriesData.filter(
      (mC) => mC.id === selectedValue
    );
    setSubCategoriesList(
      transformCategoriesForSelectObjArr(category[0]?.expenseCategories)
    );
    setCategoryData(() => ({
      macroCategory: selectedValue,
      subCategory: "",
    }));
  };

  const handleSubCategoryChange = (event) => {
    const selectedValue = event.target.value;
    setCategoryData((prevData) => ({
      ...prevData,
      subCategory: selectedValue,
    }));
  };

  const handleChangeStatusDoc = (doc) => {
    const bodyStatus = {
      id: doc.id,
      status: doc.status === 5 ? 3 : doc.status === 6 ? 3 : 5,
    };
    changeStatus(bodyStatus).then((res) => {
      if (res.data.Result !== 1) {
        toast.error(t("DocStatus") + " " + t("not edited"));
      } else {
        toast.success(t("DocStatus") + " " + t("edited"));
      }
    });
  };

  const handleProrityDoc = (doc) => {
    const bodyPriority = {
      id: doc.id,
      isRead: doc.read ? false : true,
    };
    priorityDoc(bodyPriority).then((res) => {
      if (res.data.Result !== 1) {
        toast.error(t("DocNotEdited"));
      } else {
        toast.success(t("DocEdited"));
      }
    });
  };

  const handleCloseSingleDoc = () => {
    setCurrentDocument(null);
    setCategoryData(null);
    closeModal();
  };

  const renderForm = (doc) => {
    if (doc.cu)
      return (
        <CUFormContainer
          extractedDocument={extractedDocument}
          document={currentDocument}
          mainCategoryId={categoryData.macroCategory}
          subCategoryId={categoryData.subCategory}
          closeModal={handleCloseSingleDoc}
          typeButton={currentDocument?.status === 3 ? t("Validate") : t("Save")}
          nextDocument={handleGoToNextDocument}
          handleOpenDiscardDialog={handleOpenDiscardDialog}
          handleChangeStatusDoc={handleChangeStatusDoc}
          userIsDichCongiunta={currentDocument.userIsDichCongiunta}
          fiscalCodes={fiscalCodes}
        />
      );
    else
      return (
        <DynamicForm
          formDataFromProps={extractedDocument}
          document={currentDocument}
          mainCategory={categoryData.macroCategory}
          subCategory={categoryData.subCategory}
          subCategoryName={
            subCategoriesList?.filter(
              (e) => e.value === categoryData.subCategory
            )[0]?.label
          }
          closeModal={handleCloseSingleDoc}
          typeButton={currentDocument?.status === 3 ? t("Validate") : t("Save")}
          fiscalCodes={fiscalCodes}
          nextDocument={handleGoToNextDocument}
          handleOpenDiscardDialog={handleOpenDiscardDialog}
          changeStatus={changeStatus}
          handleChangeStatusDoc={handleChangeStatusDoc}
          userIsDichCongiunta={currentDocument.userIsDichCongiunta}
        />
      );
  };

  const renderPlainForm = () => {
    return (
      <PlainForm
        document={currentDocument}
        mainCategory={categoryData.macroCategory}
        subCategory={categoryData.subCategory}
        subCategoryName={
          subCategoriesList?.filter(
            (e) => e.value === categoryData.subCategory
          )[0]?.label
        }
        closeModal={handleCloseSingleDoc}
        typeButton={currentDocument?.status === 3 ? t("Validate") : t("Save")}
        fiscalCodes={fiscalCodes}
        nextDocument={handleGoToNextDocument}
        handleOpenDiscardDialog={handleOpenDiscardDialog}
        handleChangeStatusDoc={handleChangeStatusDoc}
      />
    );
  };

  const confirmDiscardDoc = async () => {
    rejectDocument({
      id: document.id,
      notes: notesDiscard,
    })
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data.Exception || t("DocNotDiscarded"));
          return;
        }
        toast.success(t("DocDiscarded"));
        setOpenDiscardDialog(false);
        closeModal();
      })
      .catch(() => {
        toast.error(t("DocNotDiscarded"));
      });
  };

  const handleOpenDiscardDialog = () => {
    setOpenDiscardDialog(true);
  };
  const handleCloseDiscardDialog = () => {
    setOpenDiscardDialog(false);
  };

  if (!document || !currentDocument || !categoryData) {
    return <CoreSpinner />;
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="w-full flex items-center justify-between">
          <div className="flex h-fit gap-4 items-center">
            <div className="w-fit flex">
              <Accordion className="w-full shadow-md rounded-md">
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <h4 className="m-0 mr-2">
                    {t("User") + ": " + currentDocument?.userName}
                  </h4>
                </AccordionSummary>
                <AccordionDetails>
                  <p className="m-0 mt-2">
                    <span className="font-bold">
                      {t("CF")} {t("user")}:
                    </span>{" "}
                    {currentDocument?.fiscalCodeUser || "N/A"}
                  </p>
                  {children?.Data &&
                    children?.Data?.map((el, index) => (
                      <p className="m-0" key={`children-${el.Id}-${index}`}>
                        <span className="font-bold">
                          {el.name} {el.surname}:
                        </span>{" "}
                        {el.codiceFiscale}
                      </p>
                    ))}
                  {family?.Data &&
                    family?.Data?.map((el, index) => (
                      <p className="m-0 " key={`family-${el.Id}-${index}`}>
                        <span className="font-bold">
                          {el.name} {el.surname}:
                        </span>{" "}
                        {el.codiceFiscale}
                      </p>
                    ))}
                  {(currentDocument?.vat || currentDocument?.userVAT) && (
                    <h4>
                      {t("VAT")} {currentDocument?.vat && `(${t("document")})`}{" "}
                      : {currentDocument?.vat || currentDocument?.userVAT}
                    </h4>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="w-fit flex">
              <Accordion className="w-full shadow-md rounded-md">
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {t("DocPractice")}
                </AccordionSummary>
                <AccordionDetails>
                  {currentDocument?.practiceDocuments?.length > 0 ? ( //VISUALIZZAZIONE TAG ATTIVITÀ
                    <CorePracticeTags
                      practiceDocuments={currentDocument?.practiceDocuments}
                    />
                  ) : (
                    <p className="italic m-0">{t("NoOne")}</p>
                  )}
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="w-fit flex items-center gap-4">
              <Tooltip
                title={`${
                  currentDocument.read ? t("Deactivate") : t("Activate")
                }`}
              >
                <IconButton
                  className={`
                    ${
                      currentDocument.read
                        ? "text-red-700 border-red-700 bg-red-100"
                        : "text-gray border-gray bg-stone-100"
                    }
                  `}
                  onClick={() => handleProrityDoc(currentDocument)}
                >
                  <PriorityHighRoundedIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title={t("UserCard")}>
                <IconButton
                  style={{ backgroundColor: colorPrimary, color: "white" }}
                  onClick={handleOpenUserModal}
                >
                  <PersonIcon />
                </IconButton>
              </Tooltip>
              {numPages && numPages > 1 && (
                <Tooltip title={t("SplitDoc")}>
                  <IconButton
                    style={{ backgroundColor: colorPrimary, color: "white" }}
                    onClick={handleOpen}
                  >
                    <InsertPageBreakRoundedIcon />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <Button
              style={!disablePrev ? { color: colorPrimary } : null}
              className={disablePrev ? "text-gray" : ""}
              disabled={disablePrev}
              onClick={handleGoToPreviousDocument}
            >
              <ChevronLeftIcon />
              {t("Previous")}
            </Button>

            <Button
              style={!disableNext ? { color: colorPrimary } : null}
              className={disableNext ? "text-gray" : ""}
              disabled={disableNext}
              onClick={handleGoToNextDocument}
            >
              {t("Next")}
              <ChevronRightIcon />
            </Button>
            <Button
              className=" text-red-600 hover:bg-red-50"
              onClick={handleCloseSingleDoc}
            >
              {t("Close")}
              <CloseIcon />
            </Button>
          </div>
        </div>
      </div>
      <Divider className="p-2" />

      <div className="w-full flex gap-4">
        <div className="w-7/12 mt-5">
          <AttachmentViewer
            files={currentDocument?.files}
            boundingBox={boundingBox}
            docStatus={
              <div className="flex gap-2 items-center">
                <p className="font-semibold">{t("DocStatus")}: </p>
                <CoreStatus
                  status={currentDocument?.status}
                  testo={false}
                  isSingular={true}
                />
              </div>
            }
          />
        </div>

        <div className="w-5/12 mt-6">
          <div className="flex gap-4 justify-between">
            <div className="flex flex-row w-6/12">
              <CoreSelectObjArr
                name="MacroCategorie"
                label={t("MacroCategory")}
                onChange={handleMacroCategoryChange}
                value={categoryData.macroCategory}
                items={macroCategoriesList}
              />
            </div>
            <div className="flex flex-row w-6/12">
              <CoreSelectObjArr
                name="SottoCategorie"
                label={t("Category")}
                onChange={handleSubCategoryChange}
                value={categoryData.subCategory}
                items={subCategoriesList}
              />
            </div>
          </div>

          <div
            style={{ height: "80vh", border: "1px solid lightgrey" }}
            className="w-full px-6 p mt-2 rounded-md"
          >
            {isPlainFormWithUserNotes
              ? renderPlainForm()
              : renderForm(currentDocument)}
          </div>
        </div>
      </div>

      <CoreModal
        width={"100%"}
        height={"100%"}
        onClose={handleClose}
        state={open}
        component={
          <SplitDocumentPage
            document={currentDocument}
            numPages={numPages}
            onClose={handleClose}
          />
        }
      />
      <CoreModal
        width={"100%"}
        height={"100%"}
        state={openUserModal}
        onClose={handleCloseUserModal}
        component={
          <SchedaUtente
            userId={currentDocument?.userId}
            onClose={handleCloseUserModal}
          />
        }
      />
      <CoreDialog
        reject={true}
        setNotesDiscard={setNotesDiscard}
        notesDiscard={notesDiscard}
        open={openDiscardDialog}
        title={t("Discard")}
        content={`${t("RUSure")}`}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDiscardDoc}
        closeDialog={handleCloseDiscardDialog}
        disabledButton={isRejectLoading}
      />
    </>
  );
};

export default SingleDocumentPage;
